import { render, staticRenderFns } from "./home-copyright.vue?vue&type=template&id=eb68e23e&scoped=true"
import script from "./home-copyright.vue?vue&type=script&lang=js"
export * from "./home-copyright.vue?vue&type=script&lang=js"
import style0 from "./home-copyright.vue?vue&type=style&index=0&id=eb68e23e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb68e23e",
  null
  
)

export default component.exports